module.exports = __webpack_public_path__ + "img/全国销售数量(KG).79859298.png";